import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";

const ProtectedRoute = ({ children }) => {
  const { user, isAuthLoading } = useAuth();

  if (isAuthLoading) return <Typography>Loading</Typography>;

  if (!user) {
    // User not logged in, redirect to home page
    console.log("User not logged in, redirecting to home");
    toast.error("You need to be signed in to view this page");
    return <Navigate to="/" replace />;
  }

  // User is logged in, allow access to the route
  return children;
};

export default ProtectedRoute;
